import React from 'react';
import { FaPlay } from 'react-icons/fa';
import { Fade } from 'react-reveal';
import { Link } from 'react-router-dom';

const HomeHeroSingleSlide = ({ title, subtitle, imageIndex }) => {
    return (
        <>
            <div className="tp-single-slider tp-slider-height d-flex align-items-center swiper-slide" data-swiper-autoplay="5000">
                <div className="slide-bg" style={{backgroundImage: `url(assets/img/slider/slider-bg-${imageIndex}.jpg)`}}></div>
                <div className="slider-img">
                    <img src={`assets/img/slider/slider-img-${imageIndex}.jpg`} className="img-fluid" alt="img not found" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="tp-slider-wrapper mt-60 position-relative"> 
                                <div className="tp-slider z-index">

                                    <Fade left>
                                        <h5 className="tp-slider-subtitle section__sm__title common-yellow-shape w-80 mb-35">{subtitle}</h5>
                                    </Fade>

                                    <h1 className="tp-slider-title mb-45"> 
                                        <Fade top>{title}</Fade> 
                                    </h1>

                                    <div className="tp-slider-btn">
                                        <Fade bottom>
                                            <Link to="/about" className="theme-btn text-white">
                                                <i className="flaticon-enter"></i> Encore plus</Link>
                                        </Fade>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HomeHeroSingleSlide;